/* eslint-disable n/no-unpublished-import */
import {
    Chart,
    type Point
} from "chart.js/auto";

const chartCanvas = <HTMLCanvasElement>document.getElementById("chart-canvas");
const autoRefreshButton = <HTMLButtonElement>document.getElementById("auto-refresh-button");
const resultDataElement = <HTMLDivElement|null>document.getElementById("result-data");
const temperatureDataElement = <HTMLDivElement|null>document.getElementById("temperature-data");

// eslint-disable-next-line n/prefer-global/url-search-params
const urlParameters = new URLSearchParams(window.location.search);
let resultData = <Point[]>JSON.parse(resultDataElement!.textContent!);
let temperatureData = <Point[]>JSON.parse(temperatureDataElement!.textContent!);
const temperatureNumbers = temperatureData.map((temperatureDataPoint) => {
    return temperatureDataPoint.y;
});
resultDataElement!.remove();
temperatureDataElement!.remove();
for(let i = resultData.length - 1; i > 1; i -= 1){
    if((resultData.at(i)!.x - resultData.at(i - 1)!.x) > 43200000){ // 12 hours
        resultData = resultData.slice(i);
        temperatureData = temperatureData.slice(i);
        break;
    }
}

let chart: Chart<"line", Point[], unknown>|null = null;
let canvasResizeTimeoutId: NodeJS.Timeout|undefined;
let autoRefreshTimeoutId: NodeJS.Timeout|undefined;

/**
 * Create the main history chart.
 */
function createChart(): void{
    chart = new Chart(chartCanvas, {
        type: "line",
        data: {
            datasets: [
                {
                    label: "Gas measurement",
                    data: resultData,
                    borderWidth: 1,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    yAxisID: "yGas"
                },
                {
                    label: "Temperature",
                    data: temperatureData,
                    borderWidth: 1,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    yAxisID: "yTemperature"
                }
            ]
        },
        options: {
            maintainAspectRatio: false,
            plugins: {
                tooltip: {
                    callbacks: {
                        title: (item): string => {
                            return `At ${new Date((<Point>item[0].raw).x).toLocaleTimeString()}`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    type: "linear",
                    ticks: {
                        callback: (value): string => {
                            return new Date(value).toLocaleTimeString();
                        }
                    }
                },
                yGas: {
                    type: "linear",
                    position: "left",
                    title: {
                        display: true,
                        text: "Gas value"
                    }
                },
                yTemperature: {
                    type: "linear",
                    position: "right",
                    title: {
                        display: true,
                        text: "Temperature"
                    },
                    grid: {
                        drawOnChartArea: false
                    },
                    min: Math.min(...temperatureNumbers) - 0.5,
                    max: Math.max(...temperatureNumbers) + 0.5
                }
            },
            animation: false
        }
    });
}

/**
 * Temporarily destroys the chart and creates a new one after a set time.
 */
function canvasResizeListener(): void{
    if(chart !== null){
        chart.destroy();
        chart = null;
    }
    clearTimeout(canvasResizeTimeoutId);
    canvasResizeTimeoutId = setTimeout(createChart, 200);
}
window.addEventListener("resize", canvasResizeListener);

createChart();

if(urlParameters.has("refresh", "true")){
    autoRefreshButton.classList.add("is-active");
    autoRefreshTimeoutId = setTimeout(() => {
        window.location.reload();
    }, 5000);
}
autoRefreshButton.addEventListener("click", () => {
    if(urlParameters.has("refresh", "true")){
        urlParameters.delete("refresh");
        window.location.search = urlParameters.toString();
        autoRefreshButton.classList.remove("is-active");
        clearTimeout(autoRefreshTimeoutId);
    }else{
        urlParameters.append("refresh", "true");
        window.location.search = urlParameters.toString();
        autoRefreshButton.classList.add("is-active");
        autoRefreshTimeoutId = setTimeout(() => {
            window.location.reload();
        }, 5000);
    }
});